import React, { Dispatch, SetStateAction} from 'react';

import { overlayOffcanvas, overlayDark } from '../utils/overlay.util';
import { offcanvasHide, offcanvasAsideHide } from '../utils/offcanvas.util';
import { dropdownHide } from '../utils/dropdown.util';

export interface AppOverlayProps {
  activeDrawer: {value: string, aside: string, button: string},
  setActiveDrawer: Dispatch<SetStateAction<{value: string, aside: string, button: string}>>
};

const AppOverlay: React.FunctionComponent<AppOverlayProps> = ({activeDrawer, setActiveDrawer}) => {
  const executeOverlayDrawer = () => {
    switch ('on') {
      case activeDrawer.aside:
        setActiveDrawer({...activeDrawer, value: 'off', aside: 'off'})
        offcanvasAsideHide('navbar-aside', 'overlay-drawer')
        break;
      case activeDrawer.value:
        setActiveDrawer({...activeDrawer, value: 'off', button: 'off'})
        offcanvasHide('button-digital-admin-pro', 'drawer-digital-admin-pro', 'overlay-drawer')
        break;
      default:
        setActiveDrawer({...activeDrawer, value: 'off', aside: 'off', button: 'off'})
        overlayOffcanvas('overlay-drawer', 'navbar-aside', ['button-digital-admin-pro'], ['drawer-digital-admin-pro'])
        break;
    }
  }

  const executeOverlayMenu = () => {
    switch (true) {
      case document.getElementById('button-notifications')?.classList.contains('active'):
        dropdownHide('button-notifications', 'dropdown-notifications', 'overlay-menu', false)
        break;
      case document.getElementById('button-languages')?.classList.contains('active'):
        dropdownHide('button-languages', 'dropdown-languages', 'overlay-menu', false)
        break;
      case document.getElementById('button-user-profile')?.classList.contains('active'):
        dropdownHide('button-user-profile', 'dropdown-user-profile', 'overlay-menu', false)
        break;
      default:
        overlayDark('overlay-menu', ['button-notifications', 'button-languages', 'button-user-profile'], ['dropdown-notifications', 'dropdown-languages', 'dropdown-user-profile'])
        break;
    }
  }

  return (
    <>
      <div id="overlay-drawer" onClick={executeOverlayDrawer}></div>
      <div id="overlay-menu" onClick={executeOverlayMenu}></div>
    </>
  )
}

export default AppOverlay;
